import { useMutation } from '@tanstack/react-query';
import { IOperationResultNoValue } from '../../../extViewmodels';
import { useUserSession } from '../../../models/hooks/appStateHooks';

export function useAdminAccountSnapshotDeleteMuataion({
	onSuccess,
	onError,
}: {
	onSuccess?: () => void;
	onError?: (error: IOperationResultNoValue) => void;
} = {}) {
	const userSession = useUserSession();
	return useMutation({
		mutationFn: ({ id }: { id: string }) => {
			return userSession.webServiceHelper.callAsync(`admin/AccountSnapshot/${id}`, 'DELETE');
		},
		onSuccess,
		onError,
	});
}
